var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSignatureFile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/linear/folder-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "folder-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M18.3333 9.66797V14.668C18.3333 18.0013 17.5 18.8346 14.1666 18.8346H5.83329C2.49996 18.8346 1.66663 18.0013 1.66663 14.668V6.33464C1.66663 3.0013 2.49996 2.16797 5.83329 2.16797H7.08329C8.33329 2.16797 8.60829 2.53464 9.08329 3.16797L10.3333 4.83464C10.65 5.2513 10.8333 5.5013 11.6666 5.5013H14.1666C17.5 5.5013 18.3333 6.33464 18.3333 9.66797Z",
    stroke: "#51439E",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M6.66663 2.16797H14.1666C15.8333 2.16797 16.6666 3.0013 16.6666 4.66797V5.81797",
    stroke: "#51439E",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignatureFile);
export default __webpack_public_path__ + "static/media/signatureFile.0daad058f0c06338efaeaa27d807e83e.svg";
export { ForwardRef as ReactComponent };